import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsights: ApplicationInsights | null = null;

export const initializeAppInsights = () => {
  if (typeof window === 'undefined' || appInsights) return appInsights;

  appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: process.env.NEXT_PUBLIC_APPINSIGHTS_INSTRUMENTATIONKEY,
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableAjaxErrorStatusText: true,
      enableAjaxPerfTracking: true,
      enableUnhandledPromiseRejectionTracking: true,
      disableAjaxTracking: false,
      disableFetchTracking: false
    }
  });

  appInsights.loadAppInsights();
  appInsights.trackPageView();
  
  return appInsights;
};

export const getAppInsights = () => {
  if (!appInsights && typeof window !== 'undefined') {
    return initializeAppInsights();
  }
  return appInsights;
};